import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { withStyles, styled } from "@mui/styles";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Rating from "@mui/material/Rating";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import { useTheme } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import "../../styles/devices/mob_FormDialog.css";
import { useCommProvider } from "../../api/CommProvider";
import { useTranslation } from "react-i18next";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const environments_list = ["Banca", "Comercio", "Tecnología", "Otros"];
const default_form_data = {
  score_general: 3,
  score_predictions: 3,
  environments: [],
  mejoras: "",
  email: "",
};

export function FormDialog(props) {
  const { openDialog, setOpenDialog, setSentFormDialog } = props;
  const { t } = useTranslation("global")

  const { sendFormData } = useCommProvider();
  const [ formData, setFormData] = useState(default_form_data);
  const [ sendToBBDD, setSendToBBDD] = useState(false);

  const response3_ref = useRef("");
  const response4_ref = useRef("");
  const response5_ref = useRef("");

  const theme = useTheme();


  const StyledDialog = withStyles({
    root: { pointerEvents: "none" },
    paper: { pointerEvents: "auto" },
  })((props) => <Dialog {...props} />);

  const StyledRating = styled(Rating)({
    "& .MuiRating-iconFilled": {
      color: "#ff6d75",
    },
    "& .MuiRating-iconHover": {
      color: "#ff3d47",
    },
  });

  const handleClose = () => {
    setOpenDialog(false);
    setFormData(default_form_data);
    //setToggleTheme(!toggleTheme);
  };

  const sendForm = () => {
    let environments_data = formData.environments.slice();
    if (showOthersInput()) {
      environments_data.push(response3_ref.current.value);
    }

    setFormData({...formData, environments: environments_data, mejoras: response4_ref.current.value, email: response5_ref.current.value});
    setSendToBBDD(true)
  };

  useEffect(() => {
    if (sendToBBDD) {
      // sendFormData(arr_data);
      // setSentFormDialog(true);
      handleClose();
      setFormData(default_form_data);
    }
  }, [sendToBBDD]);

  function getStyles(name, environments, theme) {
    return {
      fontWeight: environments.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
    };
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setFormData({ ...formData, environments: typeof value === "string" ? value.split(",") : value });
  };

  function showOthersInput() {
    return true
  }

  return (
    <StyledDialog className="sig_Drawer_SettingsModal_Root" open={openDialog}>
      <DialogTitle> {t("sFormOpinion.formOpinion_title")} </DialogTitle>
      <DialogContent>
        <Grid container direction="column" justifyContent="center" align="center" spacing={1}>
          <Grid item>
            <img src={process.env.PUBLIC_URL + "/Logo_SignaMed.png"} alt="logo" />
          </Grid>

          <Grid item>
            <Box sx={{ p: 1, border: "1px dashed grey" }}>
              <DialogContentText id="alert-dialog-description"> {t("sFormOpinion.formOpinion_useful")} </DialogContentText>
              <StyledRating
                name="customized-color"
                size="large"
                value={formData.score_general}
                getLabelText={(value) => `${value} Heart${value !== 1 ? "s" : ""}`}
                precision={1}
                icon={<FavoriteIcon fontSize="inherit" />}
                emptyIcon={<FavoriteBorderIcon fontSize="inherit" />}
                onChange={(event, newValue) => {
                  setFormData({...formData, 'score_general': newValue});
                }}
              />
            </Box>
          </Grid>

          <Grid item>
            <Box sx={{ p: 1, border: "1px dashed grey" }}>
              <DialogContentText id="alert-dialog-description"> {t("sFormOpinion.formOpinion_recognition")} </DialogContentText>
              <StyledRating
                name="customized-color"
                size="large"
                value={formData.score_predictions}
                getLabelText={(value) => `${value} Heart${value !== 1 ? "s" : ""}`}
                precision={1}
                onChange={(event, newValue) => {
                  setFormData({...formData, 'score_predictions': newValue});
                }}
              />
            </Box>
          </Grid>

          <Grid item>
            <Box sx={{ p: 1, border: "1px dashed grey" }}>
              <DialogContentText id="alert-dialog-description"> {t("sFormOpinion.formOpinion_environment")} </DialogContentText>
              <FormControl style={{ minWidth: 250 }}>
                <Select
                  id="demo-multiple-chip"
                  multiple
                  value={formData.environments}
                  onChange={handleChange}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.4 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {environments_list.map((name) => (
                    <MenuItem key={name} value={name} style={getStyles(name, formData.environments, theme)}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <br />

              {showOthersInput() ? <TextField autoFocus margin="dense" id="name" inputRef={response3_ref} multiline rows={2} fullWidth /> : <></>}
            </Box>
          </Grid>

          <Grid item>
            <TextField autoFocus margin="dense" id="name" label= {t("sFormOpinion.form_report_suggestions")} fullWidth inputRef={response4_ref} multiline rows={4} />
          </Grid>

          <Grid item>
            <TextField autoFocus margin="dense" id="name" label= {t("sFormOpinion.form_report_email")} fullWidth inputRef={response5_ref} />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <div>
          <Button className="sig_FormDialog_Button" onClick={handleClose}>
            {t("strButton.btn_exit")}
          </Button>
          <Button className="sig_FormDialog_Button" onClick={sendForm}>
            {t("strButton.btn_send")}
          </Button>
        </div>
      </DialogActions>
    </StyledDialog>
  );
}
